var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5609 41.5781L10.1594 46.9687C9.94374 48.0234 10.914 48.8438 11.7765 48.2578L16.9515 45.0938",
    fill: "#777793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4375 41.5781L38.8391 46.9687C39.0547 48.0234 38.0844 48.8438 37.2219 48.2578L32.0469 45.0938",
    fill: "#777793"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2.90625C35.8203 2.90625 44.9844 12.8672 44.9844 25.1719C44.9844 37.4766 35.8203 47.4375 24.5 47.4375C13.1797 47.4375 4.01562 37.4766 4.01562 25.1719C4.01562 12.8672 13.1797 2.90625 24.5 2.90625Z",
    fill: "#514F6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 7.59375C33.4484 7.59375 40.6719 15.4453 40.6719 25.1719C40.6719 34.8984 33.4484 42.75 24.5 42.75C15.5516 42.75 8.32812 34.8984 8.32812 25.1719C8.32812 15.4453 15.5516 7.59375 24.5 7.59375Z",
    fill: "#F9F7E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.718 3.02339L3.04453 14.625C0.133594 11.4609 0.133594 6.18746 3.04453 3.02339C5.95547 -0.140669 10.807 -0.257857 13.718 3.02339Z",
    fill: "#FCDA4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2812 3.02344L45.9547 14.625C48.8656 11.4609 48.8656 6.1875 45.9547 3.02344C43.0438 -0.257813 38.1922 -0.257813 35.2812 3.02344Z",
    fill: "#FCDA4F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0391 8.76562H23.9609V12.2812H25.0391V8.76562Z",
    fill: "#BEBECC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0391 38.0625H23.9609V41.5781H25.0391V38.0625Z",
    fill: "#BEBECC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4948 13.9846L34.7324 13.156L32.4454 15.6419L33.2077 16.4705L35.4948 13.9846Z",
    fill: "#BEBECC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5534 34.7007L15.791 33.8721L13.504 36.358L14.2663 37.1866L16.5534 34.7007Z",
    fill: "#BEBECC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5938 24.5859H36.3594V25.7578H39.5938V24.5859Z",
    fill: "#BEBECC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6406 24.5859H9.40625V25.7578H12.6406V24.5859Z",
    fill: "#BEBECC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8509 37.188L35.6133 36.3594L33.3263 33.8735L32.5639 34.7021L34.8509 37.188Z",
    fill: "#BEBECC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6732 16.4712L16.4355 15.6426L14.1485 13.1567L13.3862 13.9853L15.6732 16.4712Z",
    fill: "#BEBECC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9688 26.3438H24.5C23.8531 26.3438 23.4219 25.875 23.4219 25.1719V15.7969C23.4219 15.0937 23.8531 14.625 24.5 14.625C25.1469 14.625 25.5781 15.0937 25.5781 15.7969V22.8281C25.5781 23.5312 26.0094 24 26.6562 24H30.9688C31.6156 24 32.0469 24.4688 32.0469 25.1719C32.0469 25.875 31.6156 26.3438 30.9688 26.3438Z",
    fill: "#514F6D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27.5156C25.6909 27.5156 26.6562 26.4663 26.6562 25.1719C26.6562 23.8775 25.6909 22.8281 24.5 22.8281C23.3091 22.8281 22.3438 23.8775 22.3438 25.1719C22.3438 26.4663 23.3091 27.5156 24.5 27.5156Z",
    fill: "#FCDA4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7bc3b3c50fc0d0fb3a0843fc26b625c8.svg";
export { ForwardRef as ReactComponent };